import "core-js";
//import "./Container/wydr";
import App from "./Container/App";
import * as serviceWorker from "./serviceWorker";
import CssBaseline from "@material-ui/core/CssBaseline";
import { UserModeProvider } from "@UserModeContext";
import "./index.css";
import { createGenerateClassName, StylesProvider } from "@material-ui/styles";
import ErrorBoundary from "./Components/ErrorBoundary";
const Root = () => {
	const generateClassName = createGenerateClassName({
		disableGlobal: true,
		productionPrefix: "eqsm",
		seed: "eqsm",
	});

	return (
		<StylesProvider generateClassName={generateClassName}>
			<UserModeProvider>
				<CssBaseline />
				<ErrorBoundary>
					<App />
				</ErrorBoundary>
			</UserModeProvider>
		</StylesProvider>
	);
};

const rootElement = document.getElementById("root");

window.ReactDOM.render(<Root key="root" />, rootElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
